import { jsx } from "react/jsx-runtime";
import { DEFAULT_HEADER_TEXT_ALIGN, DEFAULT_STRIP_TEXT_COLOR, DEFAULT_STRIP_BACKGROUND_COLOR } from "../constants.js";
import { MarketingTypography } from "../../MarketingTypography/index.js";
function CardStrip({
  text,
  textColor,
  backgroundColor,
  alignment = "center",
  isDisableLinks = false
}) {
  if (!text) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    MarketingTypography,
    {
      sx: {
        background: backgroundColor || DEFAULT_STRIP_BACKGROUND_COLOR,
        color: textColor || DEFAULT_STRIP_TEXT_COLOR,
        textAlign: alignment || DEFAULT_HEADER_TEXT_ALIGN
      },
      isMarkdown: true,
      variant: "subheading",
      isDisableLinks,
      children: text
    }
  );
}
export {
  CardStrip
};
